// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUserConfirmForgotPasswordDto
 */
export interface IUserConfirmForgotPasswordDto {
    /**
     * Use link_id instead, the username value is ignored
     * @type {string}
     * @memberof IUserConfirmForgotPasswordDto
     * @deprecated
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserConfirmForgotPasswordDto
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof IUserConfirmForgotPasswordDto
     */
    link_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IUserConfirmForgotPasswordDto
     */
    password?: string;
}

/**
 * Check if a given object implements the IUserConfirmForgotPasswordDto interface.
 */
export function instanceOfIUserConfirmForgotPasswordDto(value: object): value is IUserConfirmForgotPasswordDto {
    return true;
}

export function IUserConfirmForgotPasswordDtoFromJSON(json: any): IUserConfirmForgotPasswordDto {
    return IUserConfirmForgotPasswordDtoFromJSONTyped(json, false);
}

export function IUserConfirmForgotPasswordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUserConfirmForgotPasswordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'code': json['code'] == null ? undefined : json['code'],
        'link_id': json['link_id'] == null ? undefined : json['link_id'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}

export function IUserConfirmForgotPasswordDtoToJSON(json: any): IUserConfirmForgotPasswordDto {
    return IUserConfirmForgotPasswordDtoToJSONTyped(json, false);
}

export function IUserConfirmForgotPasswordDtoToJSONTyped(value?: IUserConfirmForgotPasswordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'code': value['code'],
        'link_id': value['link_id'],
        'password': value['password'],
    };
}

